import React from "react";
import { Dialog, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material";
import { ReportProblemOutlined } from "@mui/icons-material";

import PropTypes from "prop-types";

const ConfirmationModal = ({ 
    open, 
    onClose, 
    onConfirm, 
    title = `Questa operazione è irreversibile.`,
    subtitle = 'Vuoi procedere?',
    message = "Eliminando il tuo account, tutti i dati associati, incluse campagne attive, saldo residuo e storico dei pagamenti saranno cancellati in modo permanente.",
    cancelText = "ANNULLA", 
    confirmText = "CONFERMA",
    confirmColor = "#e00036", 
    cancelColor = "#0b3d87",
    icon = <ReportProblemOutlined sx={{ color: "white", fontSize: 50 }}/>
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogContent sx={{
                overflowX: "hidden",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                padding: "32px 28px 24px"
            }}>
                {/* Icona con alone morbido nel colore dell'azione */}
                <Box sx={{
                    width: 84,
                    height: 84,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    marginBottom: 2.5,
                    backgroundColor: confirmColor,
                    boxShadow: `0 0 0 8px ${confirmColor}1f`
                }}>
                    {icon}
                </Box>

                {/* Titolo */}
                <Typography variant="h6" sx={{ fontFamily: "Rubik", fontWeight: 800, color: "#0b3d87", lineHeight: 1.25 }}>
                    {title}
                </Typography>

                <Typography variant="h6" sx={{ fontFamily: "Rubik", fontWeight: 800, color: "#0b3d87", lineHeight: 1.25, marginBottom: 1 }}>
                    {subtitle}
                </Typography>

                {/* Messaggio */}
                <Typography sx={{ fontFamily: "Rubik", fontSize: "14px", color: "#64748b", maxWidth: "400px", marginBottom: 3, lineHeight: 1.5 }}>
                    {message}
                </Typography>

                {/* Pulsanti: annulla come azione secondaria (ghost), conferma prominente */}
                <DialogActions sx={{ display: "flex", gap: 1.5, justifyContent: "center", width: "100%", p: 0 }}>
                    <Button
                        onClick={onClose}
                        disableElevation
                        sx={{ fontFamily: "Rubik",
                            backgroundColor: "#f1f5f9",
                            color: cancelColor,
                            fontWeight: 700,
                            padding: "9px 22px",
                            borderRadius: "12px",
                            "&:hover": { backgroundColor: "#e2e8f0" }
                        }}>
                        {cancelText}
                    </Button>
                    <Button
                        onClick={onConfirm}
                        disableElevation
                        sx={{ fontFamily: "Rubik",
                            backgroundColor: confirmColor,
                            color: "white",
                            fontWeight: 700,
                            padding: "9px 22px",
                            borderRadius: "12px",
                            boxShadow: `0 6px 16px ${confirmColor}3d`,
                            transition: "all 0.2s ease",
                            "&:hover": { filter: "brightness(0.92)", transform: "translateY(-1px)" }
                        }}>
                        {confirmText}
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

ConfirmationModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    message: PropTypes.string,
    cancelText: PropTypes.string,
    confirmText: PropTypes.string,
    confirmColor: PropTypes.string,
    cancelColor: PropTypes.string,
    icon: PropTypes.node
};

export default ConfirmationModal; 